type GenericObject = { [key: string]: any };

export const saveSessionStorage = (sessionName: string, sessionValue: GenericObject) => {
  sessionStorage.removeItem(sessionName);
  sessionStorage.setItem(sessionName, JSON.stringify(sessionValue));
};
